// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1TkO0","buttons":"PendingPaymentAlert_buttons__XsYls"};